import { Car, Sparkles, Star, Plus } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const GALLERY = [
  "/brand/work1.jpeg",
  "/brand/after.webp",
  "/brand/work3.jpeg",
  "/brand/work2.jpeg",
  "/brand/work4.webp",
  "/brand/work5.webp",
];

const WHAT_WE_DO = [
  { icon: Car, title: "Exterior wash", text: "Foam wash, wheels, tire shine and a spotless hand dry." },
  { icon: Sparkles, title: "Interior deep clean", text: "Full vacuum, surfaces wiped, windows and stain removal." },
  { icon: Star, title: "Full & premium details", text: "Inside and out — sealant, clay bar and paint protection." },
  { icon: Plus, title: "Add-ons", text: "Pet hair, plastic restoration, engine bay and stain extraction." },
];

export default function Gallery() {
  return (
    <section id="gallery" className="bg-cream py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-5">
        <Reveal>
          <Eyebrow>Our work</Eyebrow>
          <h2 className="mt-4 max-w-2xl font-display text-3xl leading-tight sm:text-5xl">
            What we do
          </h2>
          <p className="mt-4 max-w-md text-ink/60">
            Real results from real cars — here&apos;s the kind of shine you can expect.
          </p>
        </Reveal>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {WHAT_WE_DO.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.06}>
              <div className="flex h-full flex-col rounded-2xl border border-ink/15 p-6">
                <s.icon size={22} />
                <h3 className="mt-4 font-display text-lg">{s.title}</h3>
                <p className="mt-2 text-sm text-ink/60">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3">
          {GALLERY.map((src, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <div className="aspect-[4/5] overflow-hidden rounded-2xl border border-ink/10">
                <img
                  src={src}
                  alt="Pine & Shine detailing work"
                  className="h-full w-full object-cover transition-transform duration-500 hover:scale-105"
                />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
